import { partial } from "lodash";

export interface NameId {
    name: string;
    id: number;
}

export enum Gender {
    Female = 1,
    Male = 2,
    Unknown = 3
}

export enum CheckState {
    Empty = 0,
    Selected = 1,
    Partial = 2
}
